import { render } from "./StepUploadFile.vue?vue&type=template&id=22c60e34&scoped=true"
import script from "./StepUploadFile.vue?vue&type=script&lang=js"
export * from "./StepUploadFile.vue?vue&type=script&lang=js"

import "./StepUploadFile.vue?vue&type=style&index=0&id=22c60e34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c60e34"]])

export default __exports__